<template>
    <div class="relative" >
        <div id="search-container" class="flex transition-all transform  rounded-xl border-gray" :class="focused?' bg-white shadow-lg':'bg-white border'">
            <i class="m-3 fas fa-search text-gray"></i>
            <input :class="focused?'bg-white':'bg-white'" class="w-full p-2 transition-all rounded-lg focus:outline-none focus-visible:ring- text-gray" type="text" name="search" placeholder="Buscar ..." @blur="focused=false"  @focus="focused=true" @keyup="searchFruit" v-model="search">
        </div>

        <transition name="search">
            <div class="absolute right-0 z-50 w-full p-5 bg-white shadow-lg rounded-b-xl scrollbar-hidden top-8" id="search-dropdown" v-if="search.length>3&&focused">
                <div v-if="fruits.length>0">
                    <span class="text-enriqueto_green">Frutas</span>
                    <Link v-for="(fruit, index) in fruits" class="flex border-light_gray" :class="index!=fruits.length-1?'border-b':''" :key="fruit.id" :href="$page.props.isAdmin==true ? '/admin/fruit/'+fruit.id : '/fruit/'+fruit.slug ">
                        <img
                            class="object-cover w-10 h-10 my-5 align-middle bg-white border-2 rounded-full border-enriqueto_green"
                            :src="fruit.image"
                            :alt="fruit.name"
                            width="40"
                            height="40"
                            loading="lazy"
                            decoding="async"
                        />
                        <h2 class="py-2 m-5 align-middle text-enriqueto_green">
                            {{fruit.name}}
                        </h2>
                        <h2 class="py-2 m-5 align-middle text-enriqueto_green">
                            {{usePriceFormat(fruit.price)}}
                        </h2>
                    </Link>
                </div>
                <div v-if="categories.length>0">
                    <span class="text-enriqueto_green">Categorias</span>
                    <Link v-for="category in categories" class="block" :key="category.id" :href="$page.props.isAdmin==true ? '/category/'+category.id+'/fruits' : '/category/'+category.id+'/fruits' ">
                        <h2 class="py-2 text-enriqueto_green">
                            {{category.name}}
                        </h2>
                    </Link>
                </div>
                <div v-if="taxonomyTerms.length>0" class="mt-4">
                    <span class="font-bold text-enriqueto_green">Taxonomía</span>
                    <Link
                        v-for="term in taxonomyTerms"
                        :key="term.slug"
                        :href="term.url"
                        class="flex items-center justify-between gap-4 py-3 border-b border-light_gray last:border-b-0"
                    >
                        <div>
                            <p class="text-xs font-bold tracking-wider uppercase text-gray">{{term.rank}}</p>
                            <h2 class="mt-1 font-bold text-enriqueto_green">{{term.name}}</h2>
                        </div>
                        <span class="material-icons text-enriqueto_green" aria-hidden="true">arrow_forward</span>
                    </Link>
                </div>

            </div>
        </transition>
    </div>
</template>

<script>
import { computed, ref } from 'vue'
import axios from 'axios'
import { Link,usePage } from '@inertiajs/inertia-vue3'
import usePriceFormat from '../../Services/usePriceFormat'

export default {
    components: {Link},
    setup(){
        const search = ref('')
        const fruits = ref([])
        const categories = ref([])
        const taxonomyTerms = ref([])
        const focused = ref(false)
        const searchFruit = ()=>{
            if(search.value.length>3){
                axios.get('/fruit/search/'+search.value)
                .then(function (response) {
                    fruits.value = response.data.fruits
                    categories.value = response.data.categories
                    taxonomyTerms.value = response.data.taxonomy_terms || []
                })
            }
        }

        return{
            search,
            fruits,
            searchFruit,
            categories,
            taxonomyTerms,
            focused,
            usePriceFormat
        }
    }
}
</script>

<style>
    #search-dropdown{
        overflow-y: scroll;
        max-height: 300px;
    }
    #search-container{
        padding:1px;
    }
    .search-enter-active {
        animation: finished .5s reverse;
    }
    .search-leave-active {
        animation: finished .5s;
    }
    @keyframes finished {
        0% { opacity: 1;margin-top:20px;}
        100% { opacity: 0;margin-top:0px;}
    }
</style>
